/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LevelUpEntry } from './LevelUpEntry';
import {
    LevelUpEntryFromJSON,
    LevelUpEntryFromJSONTyped,
    LevelUpEntryToJSON,
    LevelUpEntryToJSONTyped,
} from './LevelUpEntry';

/**
 * 
 * @export
 * @interface LevelUpTable
 */
export interface LevelUpTable extends Array<LevelUpEntry> {
}

/**
 * Check if a given object implements the LevelUpTable interface.
 */
export function instanceOfLevelUpTable(value: object): value is LevelUpTable {
    return true;
}

export function LevelUpTableFromJSON(json: any): LevelUpTable {
    return LevelUpTableFromJSONTyped(json, false);
}

export function LevelUpTableFromJSONTyped(json: any, ignoreDiscriminator: boolean): LevelUpTable {
    return json;
}

export function LevelUpTableToJSON(json: any): LevelUpTable {
    return LevelUpTableToJSONTyped(json, false);
}

export function LevelUpTableToJSONTyped(value?: LevelUpTable | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

